export default "__VITE_ASSET__CgJq$Vem__"